<app-oc-post-modal
  #ocPostModal
  [title]="app.text.history.manufacturerHistory"
></app-oc-post-modal>
<div class="container-fluid">
  <!-- First line -->
  <div class="row">
    <!-- Search Input for filter -->
    <div class="col-md-12 d-flex flex-row p-2">
      <!-- Filter options -->
      @for (type of filterModes; track type) {
        <div>
          <button
            type="button"
            role="menu"
            class="btn btn-sm badge m-1"
            [ngClass]="{ 'badge-active': app.OCHome.selectedType === type }"
            (click)="setType(type)"
            >
            @if (app.OCHome.selectedType !== type) {
              <i
                class="fa-light fa-circle-dot"
              ></i>
            }
            @if (app.OCHome.selectedType === type) {
              <i
                class="fa-regular fa-circle-dot"
              ></i>
            }
            {{ getTextDisplay(type) }}
          </button>
        </div>
      }
      <!-- Filter input -->
      <div class="search flex-grow-1 dropdown">
        @if (
          !app.OCHome.isFilterSelected && app.OCHome.selectedType !== 'tag'
          ) {
          <input
            type="text"
            class="input input-search mt-1"
            placeholder="Search for posts..."
            [(ngModel)]="app.OCHome.searchWords[app.OCHome.selectedType]"
          (keydown.enter)="
            isSelected(app.OCHome.selectedType); app.OCHome.updateOCPosts()
          "
            />
        }
        @if (
          !app.OCHome.isFilterSelected && app.OCHome.selectedType === 'tag'
          ) {
          <input
            type="text"
            class="input input-search mt-1"
            placeholder="Select a tag..."
            readonly
            [(ngModel)]="app.OCHome.searchWords[app.OCHome.selectedType]"
            data-bs-toggle="dropdown"
            aria-expanded="false"
            />
        }
        @if (
          !app.OCHome.isFilterSelected && app.OCHome.selectedType === 'tag'
          ) {
          <ul
            class="dropdown-menu"
            >
            @for (tag of app.OCHome.tags; track tag) {
              <li>
                <a
                  class="dropdown-item pointer"
              (click)="
                app.OCHome.filterByTag(tag); isSelected(app.OCHome.selectedType)
              "
                  >
                  <div
                    class="credits tag p-1 ms-auto"
                [ngStyle]="
                  app.OCPostItem.getTagColor(
                    app.fieldId.ocPost.tagCategory,
                    tag
                  )
                "
                    >
                    {{
                    app.field.getOptionText(app.fieldId.ocPost.tagCategory, tag)
                    }}
                  </div>
                </a>
              </li>
            }
          </ul>
        }
        @if (app.OCHome.isFilterSelected) {
          <button
            class="btn btn-sm search-btn me-0"
            type="button"
            (click)="clearFilter()"
            >
            {{ app.OCHome.selectedValue }}
            <i class="fa-light fa-times clear-icon"></i>
          </button>
        }
        <button
          class="btn search-btn mt-1"
          (click)="
            isSelected(app.OCHome.selectedType); app.OCHome.updateOCPosts()
          "
          >
          <i class="fa-solid fa-magnifying-glass"></i>
        </button>
      </div>
      <!-- Sorting -->
      <div class="dropdown mt-1">
        <button
          class="btn dropdown-toggle"
          type="button"
          id="sortOptions"
          data-bs-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
          >
          <div class="icon-center me-1">
            <i class="fas fa-sort-alt menu-icons"></i>
          </div>
          <span>&nbsp;{{ app.text.home.sort }}&nbsp;</span>
          @if (app.OCHome.sortingOrder === 'descending') {
            <span
              class="text-danger"
              >&nbsp;{{ app.text.post.newest }}&nbsp;</span
              >
            }
            @if (app.OCHome.sortingOrder === 'ascending') {
              <span
                class="text-danger"
                >&nbsp;{{ app.text.post.oldest }}&nbsp;</span
                >
              }
            </button>
            <div class="dropdown-menu" aria-labelledby="sortOptions">
              <div class="dropdown-item pointer">
                <i class="fas fa-sort-amount-down text-danger"></i>
                <a
              (click)="
                app.OCHome.sortingOrder = 'descending';
                app.OCHome.sortPosts('descending')
              "
                  >
                  {{ app.text.ocPost.sortToOldest }}</a
                  >
                </div>
                <div class="dropdown-item pointer">
                  <i class="fas fa-sort-amount-up text-danger"></i>
                  <a
              (click)="
                app.OCHome.sortingOrder = 'ascending';
                app.OCHome.sortPosts('ascending')
              "
                    >
                    {{ app.text.ocPost.sortToNewest }}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Second line -->
        <div class="row mb-2 bottom-line"></div>

        <!-- 3th line - Content -->
        <div class="row">
          <!-- First Section (2/5) -->
          <div class="col-md-4 col-sm-12">
            <div class="mb-2 card d-flex">
              <div class="d-flex align-items-center card-header">
                <img
                  class="profile-image"
            [src]="
              app.profile.ownProfilePicture != null
                ? app.file.getUrl(app.profile.ownProfilePicture)
                : app.url.profile.defaultImage
            "
                  />

                <!-- New post -->
                <button
                  class="btn btn-sm input-search btn-new-post flex-grow-1 m-1"
                  (click)="ocPostModal.open()"
                  >
                  New post: {{ app.text.ocPost.postQuestion }}
                </button>
              </div>
            </div>
            <div id="scroll" class="scroll mb-2" (scroll)="onScroll($event)">
              @for (post of app.OCHome.posts; track post) {
                <div>
                  <app-oc-post-item [post]="post"></app-oc-post-item>
                </div>
              }

              @if (loading) {
                <div class="spinner loading">
                  <div class="spinner-icon"></div>
                  <span>Loading more posts...</span>
                </div>
              }

              @if (noMorePosts) {
                <div class="spinner no-more">
                  <span>No more posts</span>
                </div>
              }
            </div>
          </div>
          <!-- Second Section (2/5) -->
          <div class="col-md-8 col-sm-12">
            @if (app.OCHome.posts.length == 0 && app.OCHome.isFilterSelected) {
              <div
                class="d-flex justify-content-center"
                >
                <div class="card no-results-card">
                  <i class="fa-solid fa-circle-xmark no-results-icon"></i>
                  <div class="no-results mb-3">No matching search results</div>
                  <div class="mb-4">
                    No posts match your current filters. Try adjusting your search or
                    using different keywords to find results.
                  </div>
                  <div class="d-flex justify-content-center">
                    <button
                      class="btn btn-sm sendEmailBtn"
                      type="button"
                      (click)="clearFilter()"
                      >
                      Clear All Filters
                    </button>
                  </div>
                </div>
              </div>
            }

            @if (app.OCHome.posts.length == 0 && !app.OCHome.isFilterSelected) {
              <div
                class="d-flex justify-content-center"
                >
                <div class="card no-results-card">
                  <i class="fa-solid fa-circle-xmark no-results-icon"></i>
                  <div class="no-results mb-3">No posts available</div>
                </div>
              </div>
            }

            @if (app.OCHome.posts.length > 0) {
              <div>
                <app-oc-post></app-oc-post>
              </div>
            }
          </div>
          <!-- Third Section (1/5) Attachments and Post Image -->
        </div>
      </div>
